<script setup lang="ts">
import FaqItem from "@/views/FaqPage/components/FaqItem.vue";
import {slugify} from "@/helpers/text.helper";

interface FaqData {
    title: string;
    questions: FaqItem[];
}

export interface FaqItem {
    Question: string;
    Answer: string;
    NodeId: number;
}

declare let _faqData: FaqData[];
const faqData = _faqData;
</script>

<template>
    <div class="row ">
        <aside class="col-xs-12 col-md-4">
            <ul class="list-unstyled list-group">
                <li v-for="(category) in faqData" :key="'title' + category.title">
                    <a :href="'#' + slugify(category.title)"
                       class="list-group-item js-scroll-to">{{ category.title }}</a>
                </li>
            </ul>
        </aside>
        
        <main class="col-xs-12 col-md-8">
            <section class="faq-wrapper" v-for="(category, catIndex) in faqData" :key="category.title"
                     :id="slugify(category.title)">
                <h2 class="h3 faq-title">{{ category.title }}</h2>
                <div class="panel-group faq-item" :id="'accordion-' + catIndex" role="tablist" aria-multiselectable="false">
                    <FaqItem v-for="(question) in category.questions" :parent-id="'accordion-' + catIndex" :faq-item="question" ></FaqItem>
                </div>
            </section>
        </main>
    </div>
</template>